// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".youtube-btn[data-v-c466c3a2]{left:20px;position:absolute;top:8px}", "",{"version":3,"sources":["webpack://./resources/js/user/Videos.vue"],"names":[],"mappings":"AACA,8BAGE,SAAA,CAFA,iBAAA,CACA,OACF","sourcesContent":["\n.youtube-btn {\n  position: absolute;\n  top: 8px;\n  left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
